<template>
  <OrderDiv>
    <!-- ! 헤더 버튼 영역 -->
    <OrderHeaderArea :class="{ 'blurred': isTestUser }">
      <OrderHeaderButtonArea class="header-buttons">
        <!-- * 검색 입력 -->
        <OrderSection>
          <OrderSearchWrapper>
            <OrderSearchInput v-model="searchQuery" placeholder="검색어를 입력하세요" @keyup.enter="fetchOrders" />
            <OrderSearchBtn @click="fetchOrders">
              <Magnify />
            </OrderSearchBtn>
            <OrderSearchBtn @click="showSearchPopup">
              <TextSearchVariant />
            </OrderSearchBtn>
          </OrderSearchWrapper>
        </OrderSection>

        <!-- * 날짜 조회 -->
        <OrderSection>
          <DatepickerWrapper>
            <Datepicker v-model:value="startDate" :lang="ko" placeholder="시작일" style="width: 120px;" />
            <DateSeparator>~</DateSeparator>
            <Datepicker v-model:value="endDate" :lang="ko" placeholder="종료일" style="width: 120px;" />
            <OrderButton @click="fetchOrders">날짜조회</OrderButton>
            <OrderDateButton @click="setDateRange('today')">당일</OrderDateButton>
            <OrderDateButton @click="setDateRange('yesterday')">전일</OrderDateButton>
            <OrderDateButton @click="setDateRange('thisMonth')">당월</OrderDateButton>
            <OrderDateButton @click="setDateRange('lastMonth')">전월</OrderDateButton>
            <OrderDateButton @click="setDateRange('all')">전체</OrderDateButton>
          </DatepickerWrapper>
        </OrderSection>

        <!-- * 피드백 -->
        <OrderSection class="feedback-section">
          <FeedbackNotification />
        </OrderSection>
      </OrderHeaderButtonArea>

      <!-- * 상세 검색 태그 -->
      <OrderSection v-if="hasDetailSearchFilters">
        <DetailSearchTagsWrapper>
          <DetailSearchTagsTitle>적용된 검색 조건:</DetailSearchTagsTitle>
          <DetailSearchTagsContainer>
            <DetailSearchTag v-for="(value, key) in detailedSearchParams" :key="key" @click="removeSearchFilter(key)">
              <DetailSearchTagText>{{ getFilterDisplayName(key, value) }}</DetailSearchTagText>
              <DetailSearchTagClose>×</DetailSearchTagClose>
            </DetailSearchTag>
          </DetailSearchTagsContainer>
          <ClearAllFiltersButton @click="clearAllFilters">
            전체 삭제
          </ClearAllFiltersButton>
        </DetailSearchTagsWrapper>
      </OrderSection>
    </OrderHeaderArea>

    <!-- !Order Status Area -->
    <OrderTableArea class="table-container">

      <!-- * 상단 버튼 영역 -->
      <OrderTableButtonsContainer>
        <OrderTableLeftButtons>
          <OrderUpButton @click="showModal = true">주문서 입력</OrderUpButton>
          <OrderDeleteBtn @click="confirmDeleteOrders">주문서 삭제</OrderDeleteBtn>
          <OrderPageSelect v-model="contentsSize" @change="fetchOrders">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </OrderPageSelect>&nbsp;개씩 보기
        </OrderTableLeftButtons>

        <OrderTableRightButtons>
          <ClaimStatusLegend>
            <ClaimStatusTitle>상담중 상태</ClaimStatusTitle>
            <ClaimStatusItems>
              <ClaimStatusItem>
                <RightClaimStatusIcon class="completed">
                  <CircleOutline :size="16" />
                </RightClaimStatusIcon>
                <RightClaimStatusText>상담중</RightClaimStatusText>
              </ClaimStatusItem>
              <ClaimStatusItem>
                <RightClaimStatusIcon class="not-claimed">
                  <CloseThick :size="16" />
                </RightClaimStatusIcon>
                <RightClaimStatusText>미상담</RightClaimStatusText>
              </ClaimStatusItem>
            </ClaimStatusItems>
          </ClaimStatusLegend>
          <!-- 청구 상태 범례 -->
          <ClaimStatusLegend>
            <ClaimStatusTitle>청구 상태</ClaimStatusTitle>
            <ClaimStatusItems>
              <ClaimStatusItem>
                <RightClaimStatusIcon class="completed">
                  <CircleOutline :size="16" />
                </RightClaimStatusIcon>
                <RightClaimStatusText>청구완료</RightClaimStatusText>
              </ClaimStatusItem>
              <ClaimStatusItem>
                <RightClaimStatusIcon class="in-progress">
                  <TriangleOutline :size="16" />
                </RightClaimStatusIcon>
                <RightClaimStatusText>청구중</RightClaimStatusText>
              </ClaimStatusItem>
              <ClaimStatusItem>
                <RightClaimStatusIcon class="not-claimed">
                  <CloseThick :size="16" />
                </RightClaimStatusIcon>
                <RightClaimStatusText>미청구</RightClaimStatusText>
              </ClaimStatusItem>
            </ClaimStatusItems>
          </ClaimStatusLegend>
        </OrderTableRightButtons>
      </OrderTableButtonsContainer>

      <!-- <OrderTableButtonArea class="header-buttons">
        <OrderTableButton @click="fetchStatus(0)" :class="{ active: activeStatus === 0 }">
          <OrderStatusTitle class="all">전체</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[0] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(1)" :class="{ active: activeStatus === 1 }">
          <OrderStatusTitle class="unconfirm">미확정</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[1] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(2)" :class="{ active: activeStatus === 2 }">
          <OrderStatusTitle class="confirm">확정</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[2] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(3)" :class="{ active: activeStatus === 3 }">
          <OrderStatusTitle class="release">출고</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[3] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(4)" :class="{ active: activeStatus === 4 }">
          <OrderStatusTitle class="councel">상담중</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[4] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(5)" :class="{ active: activeStatus === 5 }">
          <OrderStatusTitle class="return">반품</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[5] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(6)" :class="{ active: activeStatus === 6 }">
          <OrderStatusTitle class="as">A/S</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[6] }}</OrderStatusCnt>
        </OrderTableButton>
      </OrderTableButtonArea> -->
      <OrderTableButtonArea class="header-buttons">
        <OrderTableButton @click="fetchStatus(0)" :class="{ active: activeStatus === 0 }">
          <OrderStatusTitle class="all">전체</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[0] }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(1)" :class="{ active: activeStatus === 1 }">
          <OrderStatusTitle class="oxygen">산소</OrderStatusTitle>
          <OrderStatusCnt>{{ oxygenOrderCount }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(2)" :class="{ active: activeStatus === 2 }">
          <OrderStatusTitle class="diabetes">당뇨</OrderStatusTitle>
          <OrderStatusCnt>{{ diabetesOrderCount }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(3)" :class="{ active: activeStatus === 3 }">
          <OrderStatusTitle class="assistance">보장구</OrderStatusTitle>
          <OrderStatusCnt>{{ assistanceOrderCount }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(5)" :class="{ active: activeStatus === 5 }">
          <OrderStatusTitle class="return">반품</OrderStatusTitle>
          <OrderStatusCnt>{{ returnOrderCount }}</OrderStatusCnt>
        </OrderTableButton>
        <OrderTableButton @click="fetchStatus(6)" :class="{ active: activeStatus === 6 }">
          <OrderStatusTitle class="as">A/S</OrderStatusTitle>
          <OrderStatusCnt>{{ status_cnt[6] }}</OrderStatusCnt>
        </OrderTableButton>
      </OrderTableButtonArea>

      <!-- !Order Table Area -->
      <OrderTableScrollContainer>
        <OrderTable :class="{ 'blurred': isTestUser }">
          <OrderTableHead :class="{
            'normal-table': activeStatus !== 5 && activeStatus !== 6,
            'return-table': activeStatus === 5,
            'as-table': activeStatus === 6
          }">
            <OrderTableTr>
              <OrderTableTrTh><input type="checkbox" v-model="selectAll" @change="toggleAll" style="cursor: pointer;">
              </OrderTableTrTh>
              <template v-if="activeStatus === 5"> <!-- 반품 탭 -->
                <OrderTableTrTh class="orderdate">반품접수일</OrderTableTrTh>
                <OrderTableTrTh>고객명</OrderTableTrTh>
                <OrderTableTrTh>연락처</OrderTableTrTh>
                <OrderTableTrTh class="name2">반품품목</OrderTableTrTh>
                <OrderTableTrTh>반품수량</OrderTableTrTh>
                <OrderTableTrTh>담당자</OrderTableTrTh>
                <OrderTableTrTh>메모</OrderTableTrTh>
                <OrderTableTrTh>반품사유</OrderTableTrTh>
                <OrderTableTrTh>반품상태</OrderTableTrTh>
                <OrderTableTrTh>반품유형</OrderTableTrTh>
              </template>
              <template v-else-if="activeStatus === 6"> <!-- A/S 탭 -->
                <OrderTableTrTh class="orderdate">A/S접수일</OrderTableTrTh>
                <OrderTableTrTh>고객명</OrderTableTrTh>
                <OrderTableTrTh>연락처</OrderTableTrTh>
                <OrderTableTrTh class="name2">A/S품목</OrderTableTrTh>
                <OrderTableTrTh>수량</OrderTableTrTh>
                <OrderTableTrTh>메모</OrderTableTrTh>
                <OrderTableTrTh>A/S사유</OrderTableTrTh>
                <OrderTableTrTh>A/S상태</OrderTableTrTh>
              </template>
              <template v-else> <!-- 기본 탭 -->
                <OrderTableTrTh class="orderdate">일자</OrderTableTrTh>
                <OrderTableTrTh>고객명</OrderTableTrTh>
                <OrderTableTrTh>고객번호</OrderTableTrTh>
                <OrderTableTrTh class="name2">품목명</OrderTableTrTh>
                <OrderTableTrTh>품목<br>수량</OrderTableTrTh>
                <OrderTableTrTh class="address">배송주소</OrderTableTrTh>
                <OrderTableTrTh>보호자<br>성함</OrderTableTrTh>
                <OrderTableTrTh>연락처</OrderTableTrTh>
                <OrderTableTrTh>거래처</OrderTableTrTh>
                <OrderTableTrTh>담당자</OrderTableTrTh>
                <OrderTableTrTh>메모</OrderTableTrTh>
                <OrderTableTrTh>배송상태</OrderTableTrTh>
                <OrderTableTrTh>구분</OrderTableTrTh>
                <OrderTableTrTh v-if="activeStatus === 1 || activeStatus === 2 || activeStatus === 3"
                  class="claim-status">청구</OrderTableTrTh>
              </template>
              <OrderTableTrTh>상담중</OrderTableTrTh>
              <OrderTableTrTh>복사</OrderTableTrTh>
            </OrderTableTr>
          </OrderTableHead>
          <tbody>
            <OrderTableTr v-for="order in filteredOrders" :key="order.number" @click="openModifyModal(order)"
              class="order_tr" :class="{ 'expired-order': isClaimExpired(order) }">
              <OrderTableTrTd @click.stop>
                <input type="checkbox" v-model="order.selected" @click="toggleOrderSelection(order.num)"
                  style="cursor: pointer;">
              </OrderTableTrTd>
              <template v-if="activeStatus === 5"> <!-- 반품 탭 -->
                <OrderTableTrTd>{{ formatDate(order.return_date) }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.original_order_name }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.phone1 || order.phone2 }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.b_name3 }}</OrderTableTrTd>
                <ReturnQuantitySpan v-if="order.quantity < 0">
                  {{ order.quantity }}
                </ReturnQuantitySpan>
                <span v-else>{{ order.quantity }}</span>
                <OrderTableTrTd>{{ order.manager }}</OrderTableTrTd>
                <OrderTableTrTd>{{ truncateComment(order.memo) }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.return_request_note }}</OrderTableTrTd>
                <OrderTableTrTd>
                  <ReturnStatusTag :class="`status-${order.return_status}`">
                    {{ getReturnStatus(order.return_status) }}
                  </ReturnStatusTag>
                </OrderTableTrTd>
                <OrderTableTrTd>
                  <ReturnTypeTag :class="`type-${order.return_type}`">
                    {{ getReturnType(order.return_type) }}
                  </ReturnTypeTag>
                </OrderTableTrTd>
                <OrderTableTrTd>{{ order.consulting_status }}</OrderTableTrTd>
              </template>
              <template v-else-if="activeStatus === 6"> <!-- A/S 탭 -->
                <OrderTableTrTd>{{ formatDate(order.as_date) }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.original_order_name }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.phone1 }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.product_names }}</OrderTableTrTd>
                <OrderTableTrTd>
                  <AsQuantitySpan v-if="order.total_quantity">
                    {{ order.total_quantity }}
                  </AsQuantitySpan>
                  <span v-else>{{ order.total_quantity }}</span>
                </OrderTableTrTd>
                <OrderTableTrTd>{{ order.comment_memo }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.as_request_note }}</OrderTableTrTd>
                <OrderTableTrTd>
                  <AsStatusTag :class="`status-${order.as_status}`">
                    {{ getAsStatus(order.as_status) }}
                  </AsStatusTag>
                </OrderTableTrTd>
                <OrderTableTrTd>{{ order.consulting_status }}</OrderTableTrTd>
              </template>
              <template v-else> <!-- 기본 탭 -->
                <OrderTableTrTd>{{ formatDate(order.orderdate) }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.order_name }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.number }}</OrderTableTrTd>
                <OrderTableTrTd>
                  <template v-if="order.hasSetProduct && order.displayName">
                    <SetItemTag>[세트]</SetItemTag> {{ order.displayName }}
                  </template>
                  <template v-else>
                    {{ formatName2(order.b_name3 + ',' + order.name2) || formatHubName(order.hub_name1) }}
                  </template>
                </OrderTableTrTd>
                <OrderTableTrTd>
                  <NegativeQuantitySpan v-if="order.total_quantity < 0">
                    {{ order.total_quantity }}
                  </NegativeQuantitySpan>
                  <span v-else>{{ order.total_quantity }}</span>
                </OrderTableTrTd>
                <OrderTableTrTd>{{ order.address }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.guardname }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.phone1 }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.centername }}</OrderTableTrTd>
                <OrderTableTrTd>{{ order.manager }}</OrderTableTrTd>
                <OrderTableTrTd>{{ truncateComment(order.comment) }}</OrderTableTrTd>
                <OrderTableTrTd>{{ getDeliveryStatus(order.delivery_status) }}</OrderTableTrTd>
                <OrderTableTrTd>
                  <OrderTypeTag :class="{
                    'oxygen': getOrderTypeFromBackend(order) === 'oxygen',
                    'rental': getOrderTypeFromBackend(order) === 'rental',
                    'diabetes': getOrderTypeFromBackend(order) === 'diabetes',
                    'assistance': getOrderTypeFromBackend(order) === 'assistance',
                    'normal': getOrderTypeFromBackend(order) === 'normal'
                  }">
                    {{ getOrderTypeText(order) }}
                  </OrderTypeTag>
                </OrderTableTrTd>
                <OrderTableTrTd v-if="activeStatus === 1 || activeStatus === 2 || activeStatus === 3"
                  class="claim-status">
                  <ClaimStatusCell>
                    <ClaimStatusIcon v-if="shouldShowClaimStatus(order)" :class="getClaimStatusClass(order)">
                      <component :is="getClaimStatusIcon(order)" :size="20" />
                    </ClaimStatusIcon>
                    <span v-else>-</span>
                    <ClaimStatusText v-if="shouldShowClaimStatus(order) && getClaimStatus(order) === 'completed'">
                      {{ getClaimCountText(order) }}
                    </ClaimStatusText>
                  </ClaimStatusCell>
                </OrderTableTrTd>
              </template>
              <OrderTableTrTd>
                <RightClaimStatusIcon :class="order.payment === '기타' ? 'completed' : 'not-claimed'">
                  <component :is="order.payment === '기타' ? 'CircleOutline' : 'CloseThick'" :size="20" />
                </RightClaimStatusIcon>
              </OrderTableTrTd>
              <OrderTableTrTd>
                <OrderCopyBtn @click.stop="copyOrderData(order)">
                  <ContentCopy :size="22" />
                </OrderCopyBtn>
              </OrderTableTrTd>
            </OrderTableTr>
          </tbody>
        </OrderTable>
      </OrderTableScrollContainer>
    </OrderTableArea>

    <OrderPageCenterArea :class="{ 'blurred': isTestUser }">
      <Pagination>
        <PaginationButton @click="goToPage(currentPage - 10)" :disabled="currentPage - 10 < 1">
          <ChevronDoubleLeft :size="20" />
        </PaginationButton>
        <PaginationButton @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
          <ChevronLeft :size="20" />
        </PaginationButton>
        <PaginationNumber v-for="page in visiblePages" :key="page" @click="goToPage(page)"
          :class="{ 'current-page': page === currentPage }">
          {{ page }}
        </PaginationNumber>
        <PaginationButton @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">
          <ChevronRight :size="20" />
        </PaginationButton>
        <PaginationButton @click="goToPage(currentPage + 10)" :disabled="currentPage + 10 > totalPages">
          <ChevronDoubleRight :size="20" />
        </PaginationButton>
      </Pagination>
    </OrderPageCenterArea>
  </OrderDiv>

  <!-- * 주문서 입력 모달 -->
  <ModalPage v-model:show="showModal" :height="modal_height" :class="{ 'blurred': isTestUser }">
    <OrderUpPage @fetch-orders="fetchOrders" @close-modal="closeModal" />
  </ModalPage>
  <!-- * 주문서 수정 모달 -->
  <ModalPage v-model:show="showModifyModal" :height="modal_height" :parent="'order'" :class="{ 'blurred': isTestUser }">
    <OrderModifyPage :orderId="getOrderIdForModal()" @order-updated="fetchOrders" @close-modal="closeModal"
      @payment-updated="handlePaymentUpdated" @close-return-modal="closeReturnModal" @close-as-modal="closeAsModal" />
  </ModalPage>
</template>

<script>
import { ref, h, createApp } from 'vue';
import * as OrderCss from '@/assets/styles/order/OrderPageCss.js';

import ModalPage from '@/components/layout/ModalPage.vue';
import OrderUpPage from '@/components/order/OrderUpPage.vue';
import OrderModifyPage from '@/components/order/OrderModifyPage.vue'
import SearchPopup from '@/components/order/popup/OrderSearchPopup.vue';
import FeedbackNotification from '@/components/order/popup/FeedbackNotification.vue';

import TextSearchVariant from 'vue-material-design-icons/TextSearchVariant.vue';
import Magnify from 'vue-material-design-icons/Magnify.vue';
import Datepicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import ChevronDoubleLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronDoubleRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
import ContentCopy from 'vue-material-design-icons/ContentCopy.vue';
import CloseThick from 'vue-material-design-icons/CloseThick.vue';
import TriangleOutline from 'vue-material-design-icons/TriangleOutline.vue';
import CircleOutline from 'vue-material-design-icons/CircleOutline.vue';
import AlertCircle from 'vue-material-design-icons/AlertCircle.vue';

export default {
  name: 'OrderPage',

  components: {
    ...OrderCss,
    TextSearchVariant, Magnify, ChevronDoubleLeft, ChevronDoubleRight, ChevronLeft, ChevronRight, ContentCopy, CloseThick, TriangleOutline, CircleOutline, AlertCircle,
    ModalPage,
    OrderUpPage,
    OrderModifyPage,
    Datepicker,
    FeedbackNotification
  },
  setup() {
    const ko = {
      formatLocale: {
        months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
        weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
        weekdaysMin: ['일', '월', '화', '수', '목', '금', '토'],
        firstDayOfWeek: 0,
        firstWeekContainsDate: 1,
        meridiem: (h) => (h < 12 ? '오전' : '오후'),
        meridiemParse: /오전|오후/,
        isPM: (input) => input === '오후'
      },
      yearFormat: 'YYYY년',
      monthFormat: 'MMM',
      monthBeforeYear: false
    };

    const status_cnt = ref([0, 0, 0]);
    const selected = ref('10'); // 기본값 설정
    const showModal = ref(false);
    const searchPopupInstance = ref(null);
    const activeStatus = ref(0);
    return {
      ko,
      searchPopupInstance,
      selected,
      showModal,
      activeStatus,
      status_cnt
    };
  },
  data() {
    const today = new Date();
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    return {
      startDate: today,
      endDate: lastDayOfMonth,
      searchQuery: '',
      itemsPerPage: 10,
      modal_height: '80%',
      orders: [],
      selectAll: false,
      currentPage: 1,
      totalPages: 1,
      totalOrders: 0,
      showModifyModal: false,
      selectedOrder: null,
      contentsSize: 10,
      selectedOrderIds: [],
      asItems: [], // A/S 데이터를 저장할 배열 추가
      returnItems: [], // 반품 데이터를 저장할 배열 추가
      returnOrderCount: 0,
      claimStatusMap: new Map(), // 주문별 청구 상태 저장
      expiredClaimOrders: new Set(), // 청구 만료된 주문 ID 저장
      typeCounts: { // 타입별 카운트를 저장할 객체 추가
        oxygen: 0,
        diabetes: 0,
        assistance: 0
      },
      searchParams: {
        delivery_status: '',
        delivery_method: '',
        name3: '',
        centerName: '',
        manager: '',
        phone1: '',
        bcode: '',
        status: '0',
        orderType: '',
      },
      filterTitles: {
        delivery_status: '배송상태',
        delivery_method: '배송방법',
        name2: '품목명',
        centerName: '센터명',
        manager: '담당자',
        phone1: '연락처',
        barcode: '바코드',
        orderType: '구분'
      },
      filterValues: {
        delivery_status: {
          '1': '배송완료',
          '2': '배송대기',
          '3': '회수중',
          '4': '회수완료'
        },
        delivery_method: {
          '1': '내방',
          '2': '택배',
          '3': '물류',
          '4': '소독업체',
          '5': '공급업체'
        },
        orderType: {
          'normal': '구입',
          'rental': '대여',
          'oxygen': '산소',
          'diabetes': '당뇨',
          'assistance': '보장구'
        }
      },
      showOrderUploadModal: false,
    }
  },
  computed: {
    // test 사용자 여부 확인
    isTestUser() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return userInfo && userInfo.id === 'test';
      } catch (error) {
        return false;
      }
    },

    // 청구 상태가 있는 주문들만 필터링
    ordersWithClaimStatus() {
      const filtered = this.orders.filter(order => {
        const orderType = this.getOrderTypeFromBackend(order);
        const shouldInclude = ['oxygen', 'diabetes', 'assistance'].includes(orderType);

        return shouldInclude;
      });

      return filtered;
    },

    // 산소 주문서 개수 계산 - typeCounts 사용
    oxygenOrderCount() {
      return this.typeCounts.oxygen;
    },

    // 당뇨 주문서 개수 계산 - typeCounts 사용
    diabetesOrderCount() {
      return this.typeCounts.diabetes;
    },

    // 보장구 주문서 개수 계산 - typeCounts 사용
    assistanceOrderCount() {
      return this.typeCounts.assistance;
    },

    // 상세 검색 필터가 있는지 확인
    hasDetailSearchFilters() {
      return Object.keys(this.detailedSearchParams).length > 0;
    },

    // 상세 검색 파라미터만 필터링
    detailedSearchParams() {
      const filtered = {};
      // 필터 태그에서 제외할 키들
      const excludeKeys = [
        'search',        // 기본 검색어
        'sdate',         // 시작일
        'edate',         // 종료일
        'status',        // 상태 코드
        'page',          // 페이지
        'contentsSize'   // 페이지 크기
      ];

      Object.entries(this.filteredSearchParams).forEach(([key, value]) => {
        if (!excludeKeys.includes(key) &&
          value !== null &&
          value !== undefined &&
          value !== '' &&
          value !== '0') {
          filtered[key] = value;
        }
      });

      return filtered;
    },
    visiblePages() {
      let start = Math.floor((this.currentPage - 1) / 10) * 10 + 1;
      let end = Math.min(start + 9, this.totalPages);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    filteredSearchParams() {
      const filtered = {};
      if (this.searchQuery) {
        filtered.search = this.searchQuery;
      }
      if (this.searchParams) {
        Object.entries(this.searchParams).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '' && value !== '0') {
            filtered[key] = value;
          }
        });
      }
      return filtered;
    },

    filteredOrders() {
      let orders;

      switch (this.activeStatus) {
        case 5: // 반품 탭
          orders = this.returnItems;
          break;
        case 6: // A/S 탭
          orders = this.asItems;
          break;
        default: // 기본 탭들 (전체, 산소, 당뇨, 보장구)
          // 반품 주문서와 A/S 주문서를 제외한 일반 주문서만 필터링
          orders = this.orders.filter(order => {
            // 반품 주문서가 아닌 경우만 포함 (return_start_date가 없거나 null인 경우)
            const isNotReturnOrder = !order.return_start_date;
            // A/S 주문서가 아닌 경우만 포함 (as_start_date가 없거나 null인 경우)
            const isNotAsOrder = !order.as_start_date;

            return isNotReturnOrder && isNotAsOrder;
          });
          break;
      }

      return orders;
    }
  },

  methods: {
    // ==========================================================
    // 청구 테이블 관련
    // ==========================================================
    // 청구 차수 텍스트 반환
    getClaimCountText(order) {
      const claimStatus = this.claimStatusMap.get(order.num);

      if (!claimStatus || !claimStatus.hasClaimData) {
        return '';
      }

      // receipt_type에 따라 차수 정보 결정
      if (claimStatus.receiptType === '동시접수') {
        const homeCount = claimStatus.homeCount || '';
        const mobileCount = claimStatus.mobileCount || '';

        if (homeCount && mobileCount) {
          return `${homeCount.replace('청구', '')}/${mobileCount.replace('청구', '')}`;
        } else if (homeCount) {
          return homeCount.replace('청구', '');
        } else if (mobileCount) {
          return mobileCount.replace('청구', '');
        }
      } else if (claimStatus.receiptType === '가정용') {
        return (claimStatus.homeCount || '').replace('청구', '');
      } else if (claimStatus.receiptType === '휴대용') {
        return (claimStatus.mobileCount || '').replace('청구', '');
      }

      return '';
    },

    // 청구 상태 아이콘 컴포넌트 반환
    getClaimStatusIcon(order) {
      const status = this.getClaimStatus(order);
      switch (status) {
        case 'not_started':
          return 'CloseThick';
        case 'in_progress':
          return 'TriangleOutline';
        case 'completed':
          return 'CircleOutline';
        default:
          return 'CloseThick';
      }
    },

    // 청구 상태 표시 여부 확인
    shouldShowClaimStatus(order) {
      const orderType = this.getOrderTypeFromBackend(order);
      return ['oxygen', 'diabetes', 'assistance'].includes(orderType);
    },

    // 청구 상태 가져오기
    getClaimStatus(order) {
      const claimStatus = this.claimStatusMap.get(order.num);

      if (claimStatus) {
        // DB에서 가져온 실제 청구 상태 사용
        if (claimStatus.currentStep === 0) return 'not_started';
        if (claimStatus.currentStep < 3) return 'in_progress';
        if (claimStatus.currentStep >= 3) return 'completed';
      }

      // 기본값
      return 'not_started';
    },

    // 청구 상태 CSS 클래스 반환
    getClaimStatusClass(order) {
      const status = this.getClaimStatus(order);
      return `claim-status-${status}`;
    },

    // 청구 만료 여부 확인 메서드
    isClaimExpired(order) {
      const claimStatus = this.claimStatusMap.get(order.num);
      const isExpired = claimStatus ? claimStatus.isExpired : false;

      return isExpired;
    },

    // 주문 타입에 따른 청구 타입 결정
    getCurrentClaimType(order) {
      const orderType = this.getOrderTypeFromBackend(order);
      switch (orderType) {
        case 'oxygen':
          return 'oxygen';
        case 'diabetes':
          return 'diabetes';
        case 'assistance':
          return 'assistance';
        default:
          return 'oxygen';
      }
    },

    // 청구 상태 로드 (수정된 버전)
    async loadClaimStatusForOrder(orderId, claimType) {
      try {
        let response;

        if (claimType === 'diabetes') {
          // 당뇨소모성재료 청구 정보 조회
          response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/diabetesClaimData/${orderId}`);
        } else {
          // 산소치료 청구 정보 조회
          response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/oxygenClaimData/${orderId}`);
        }

        if (response.data && response.data.success && response.data.data.length > 0) {
          const latestClaim = response.data.data[0]; // 가장 최근 청구 정보

          let currentStep = 0;
          let currentStepText = '청구정보저장';
          let isCompleted = false;
          let isExpired = false; // 청구 만료 여부 추가

          // 청구 만료일 검토
          if (latestClaim.receipt_type) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 시간을 00:00:00으로 설정

            let endDate = null;

            // receipt_type에 따라 만료일 결정
            switch (latestClaim.receipt_type) {
              case '가정용':
                endDate = latestClaim.home_end_date ? new Date(latestClaim.home_end_date) : null;
                break;
              case '휴대용':
                endDate = latestClaim.mobile_end_date ? new Date(latestClaim.mobile_end_date) : null;
                break;
              case '동시접수':
                // 동시접수는 가정용과 동일하게 처리
                endDate = latestClaim.home_end_date ? new Date(latestClaim.home_end_date) : null;
                break;
            }

            if (endDate) {
              endDate.setHours(0, 0, 0, 0); // 시간을 00:00:00으로 설정
              isExpired = today >= endDate; // 오늘 날짜가 만료일과 같거나 지났으면 만료
            }
          }

          // status에 따라 단계 설정
          switch (latestClaim.status) {
            case '청구정보저장':
              currentStep = 0;
              currentStepText = '청구정보저장';
              isCompleted = true;
              break;
            case '환자등록':
              currentStep = 1;
              currentStepText = '환자등록';
              isCompleted = true;
              break;
            case '위임내역등록':
              currentStep = 2;
              currentStepText = '위임내역등록';
              isCompleted = true;
              break;
            case '청구등록':
              currentStep = 3;
              currentStepText = '청구등록';
              isCompleted = true;
              break;
            case '완료':
              currentStep = 3;
              currentStepText = '완료';
              isCompleted = true;
              break;
            default:
              currentStep = latestClaim.currentStep || 0;
              currentStepText = latestClaim.currentStepText || '청구정보저장';
              isCompleted = latestClaim.currentStatus === 'completed';
          }

          const claimStatus = {
            hasClaimData: true,
            currentStep: currentStep,
            currentStepText: currentStepText,
            isCompleted: isCompleted,
            isExpired: isExpired,
            receiptType: latestClaim.receipt_type,
            homeEndDate: latestClaim.home_end_date,
            mobileEndDate: latestClaim.mobile_end_date,
            homeCount: latestClaim.home_count || '',
            mobileCount: latestClaim.mobile_count || ''
          };

          // Map에 저장
          this.claimStatusMap.set(orderId, claimStatus);

          // 만료된 주문인 경우 Set에 추가
          if (isExpired) {
            this.expiredClaimOrders.add(orderId);
          } else {
            this.expiredClaimOrders.delete(orderId);
          }

          return claimStatus;
        } else {
          // 청구 정보가 없는 경우
          const claimStatus = {
            hasClaimData: false,
            currentStep: 0,
            currentStepText: '청구정보저장',
            isCompleted: false,
            isExpired: false,
            receiptType: null,
            homeEndDate: null,
            mobileEndDate: null
          };

          this.claimStatusMap.set(orderId, claimStatus);
          this.expiredClaimOrders.delete(orderId);
          return claimStatus;
        }
      } catch (error) {
        console.error(`주문 ${orderId} 청구 상태 로드 오류:`, error);

        // 에러 발생 시 기본 상태
        const claimStatus = {
          hasClaimData: false,
          currentStep: 0,
          currentStepText: '청구정보저장',
          isCompleted: false,
          isExpired: false,
          receiptType: null,
          homeEndDate: null,
          mobileEndDate: null
        };

        this.claimStatusMap.set(orderId, claimStatus);
        this.expiredClaimOrders.delete(orderId);
        return claimStatus;
      }
    },

    // loadAllClaimStatuses 메서드에 추가할 디버깅 코드
    async loadAllClaimStatuses() {
      try {
        this.isLoadingClaimStatus = true;

        // 청구 상태가 필요한 주문들만 필터링
        const ordersToLoad = this.ordersWithClaimStatus;

        if (ordersToLoad.length === 0) {
          return;
        }

        // 각 주문별로 청구 상태 로드 (병렬 처리)
        const claimStatusPromises = ordersToLoad.map(async (order) => {
          const claimType = this.getCurrentClaimType(order);
          return this.loadClaimStatusForOrder(order.num, claimType);
        });

        await Promise.all(claimStatusPromises);

      } catch (error) {
        console.error('청구 상태 로드 중 오류 발생:', error);
      } finally {
        this.isLoadingClaimStatus = false;
      }
    },

    // 모달용 주문 ID 결정 메서드
    getOrderIdForModal() {
      if (!this.selectedOrder) return null;

      // A/S 탭인 경우 as_order_id 사용
      if (this.activeStatus === 6) {
        return this.selectedOrder.as_order_id;
      }

      // 반품 탭인 경우 return_order_id 사용
      if (this.activeStatus === 5) {
        return this.selectedOrder.return_order_id;
      }

      // 일반 탭인 경우 num 사용
      return this.selectedOrder.num;
    },


    // ==========================================================
    // 상태 관련
    // ==========================================================
    getReturnStatus(code) {
      const statuses = {
        0: '접수',
        1: '승인',
        2: '회수',
        3: '검수',
        4: '환불/교환'
      };
      return statuses[code] || '접수';
    },

    getReturnType(code) {
      const types = {
        0: '다른 물건',
        1: '파손',
        2: '불량',
        3: '단순 변심'
      };
      return types[code] || '기타';
    },

    getFilterDisplayName(key, value) {
      const filterLabels = {
        'delivery_status': '배송상태',
        'delivery_method': '배송방법',
        'orderType': '구분',
        'name3': '품목명',
        'centerName': '센터명',
        'manager': '담당자',
        'phone1': '연락처',
        'bcode': '바코드',
      };

      const label = filterLabels[key] || key;

      // 특별한 값 처리
      if (key === 'delivery_status') {
        const statusLabels = {
          '1': '배송완료',
          '2': '배송대기',
          '3': '회수중',
          '4': '회수완료',
        };
        return `${label}: ${statusLabels[value] || value}`;
      }

      if (key === 'delivery_method') {
        const methodLabels = {
          '1': '내방',
          '2': '택배',
          '3': '물류',
          '4': '소독업체',
          '5': '공급업체'
        };
        return `${label}: ${methodLabels[value] || value}`;
      }

      // 구분 필터 한글 매칭 추가
      if (key === 'orderType') {
        const orderTypeLabels = {
          'oxygen': '산소',
          'diabetes': '당뇨',
          'assistance': '보장구',
          'rental': '대여',
          'normal': '구입',
        };
        return `${label}: ${orderTypeLabels[value] || value}`;
      }

      return `${label}: ${value}`;
    },

    // 개별 필터 삭제
    removeSearchFilter(key) {
      if (this.filteredSearchParams[key] !== undefined) {
        delete this.filteredSearchParams[key];

        const objectsToUpdate = [
          'searchParams',
          'queryParams',
          'filterParams',
        ];

        objectsToUpdate.forEach(objName => {
          if (this[objName] && this[objName][key] !== undefined) {
            delete this[objName][key];
            // 반응성을 위해 새 객체로 교체
            this[objName] = { ...this[objName] };
          }
        });

        this.fetchOrders(); // 검색 조건 변경 후 재검색
      }
    },

    // 모든 필터 삭제 (API 요청 파라미터 직접 수정)
    clearAllFilters() {
      const excludeKeys = ['search', 'sdate', 'edate', 'status', 'page', 'contentsSize'];

      Object.keys(this.filteredSearchParams).forEach(key => {
        if (!excludeKeys.includes(key)) {
          delete this.filteredSearchParams[key];

          // API 요청에 사용되는 모든 관련 객체에서 삭제
          const objectsToUpdate = [
            'searchParams',
            'queryParams',
            'filterParams',
            // 실제 사용하는 파라미터 객체명들을 여기에 추가
          ];

          objectsToUpdate.forEach(objName => {
            if (this[objName] && this[objName][key] !== undefined) {
              delete this[objName][key];
              // 반응성을 위해 새 객체로 교체
              this[objName] = { ...this[objName] };
            }
          });
        }
      });

      this.fetchOrders(); // 검색 조건 변경 후 재검색
    },

    // 주문 타입 확인 =====================================================================
    // 백엔드에서 받은 타입 정보로 주문 타입 결정
    getOrderTypeFromBackend(order) {
      if (order.hasOxygenGenerator) {
        return 'oxygen';
      } else if (order.hasDiabetesProduct) {
        return 'diabetes';
      } else if (order.hasAssistanceProduct) {
        return 'assistance';
      } else if (order.hasRentalProduct) {
        return 'rental';
      } else {
        return 'normal';
      }
    },
    // 주문 타입 텍스트 반환
    getOrderTypeText(order) {
      const type = this.getOrderTypeFromBackend(order);
      switch (type) {
        case 'oxygen': return '산소';
        case 'rental': return '대여';
        case 'diabetes': return '당뇨';
        case 'assistance': return '보장구';
        case 'normal': return '구입';
        default: return '구입';
      }
    },

    // 주문서 복사 =====================================================================
    copyOrderData(order) {
      try {
        console.log('order', order);
        const formatValue = (value) => {
          if (value === null || value === undefined || value === 'null') {
            return '';
          }
          return value;
        };

        // 품목 정보 파싱 및 포맷팅 함수
        const getItemsInfo = () => {
          let itemsInfo = [];
          itemsInfo.push('품목:');

          // 품목 정보 포맷팅 도우미 함수
          const formatItemInfo = (itemName, itemSize, itemNote, itemQuantity) => {
            const cleanSize = formatValue(itemSize);
            const cleanNote = formatValue(itemNote);

            let result = itemName;

            if (cleanSize && cleanSize !== '') {
              result += ` | ${cleanSize}`;
            }

            if (cleanNote && cleanNote !== '') {
              result += ` | ${cleanNote}`;
            }

            result += ` - ${itemQuantity}개`;

            return result;
          };

          // name3가 있는 경우 (쉼표로 구분된 품목들)
          if (order.b_name3 && typeof order.b_name3 === 'string') {
            const items = order.b_name3.split(',').map(item => item.trim()).filter(Boolean);

            if (items.length > 0) {
              // size, note, quantity는 쉼표로 구분된 문자열이므로 분리
              const sizes = order.size ? order.size.split(',').map(s => s.trim()).filter(Boolean) : [];
              const notes = order.note ? order.note.split(',').map(n => n.trim()).filter(Boolean) : [];
              const quantities = order.item_quantities
                ? order.item_quantities.split(',').map(q => parseInt(q.trim()) || 1)
                : [];

              items.forEach((item, idx) => {
                const size = idx < sizes.length ? sizes[idx] : '';
                const note = idx < notes.length ? notes[idx] : '';
                // 개별 수량이 있으면 사용, 없으면 기본값 1
                const itemQuantity = idx < quantities.length ? quantities[idx] : 1;

                itemsInfo.push(formatItemInfo(item, size, note, itemQuantity));
              });
              return itemsInfo;
            }
          }

          // name2가 있는 경우
          if (order.name2 && typeof order.name2 === 'string') {
            const items = order.name2.split(',').map(item => item.trim()).filter(Boolean);

            if (items.length > 0) {
              const sizes = order.size ? order.size.split(',').map(s => s.trim()).filter(Boolean) : [];
              const notes = order.note ? order.note.split(',').map(n => n.trim()).filter(Boolean) : [];
              const quantities = order.item_quantities
                ? order.item_quantities.split(',').map(q => parseInt(q.trim()) || 1)
                : [];

              items.forEach((item, idx) => {
                const size = idx < sizes.length ? sizes[idx] : '';
                const note = idx < notes.length ? notes[idx] : '';
                const itemQuantity = idx < quantities.length ? quantities[idx] : 1;

                itemsInfo.push(formatItemInfo(item, size, note, itemQuantity));
              });
              return itemsInfo;
            }
          }

          // 단일 품목인 경우 (b_name 시리즈 사용)
          if (order.b_name0 || order.b_name1 || order.b_name2 || order.b_name3 || order.b_name4) {
            const itemName = [
              formatValue(order.b_name0),
              formatValue(order.b_name1),
              formatValue(order.b_name2),
              formatValue(order.b_name3),
              formatValue(order.b_name4)
            ].filter(Boolean).join(' > ');

            const itemSize = formatValue(order.size);
            const itemNote = formatValue(order.note);
            const itemQuantity = order.quantity || 1;

            itemsInfo.push(formatItemInfo(itemName, itemSize, itemNote, itemQuantity));
          } else {
            itemsInfo.push('품목 정보 없음');
          }

          return itemsInfo;
        };

        // 복사할 데이터 형식 구성
        const copyData = [
          `주문일자: ${formatValue(this.formatDate(order.orderdate))}`,
          `고객명: ${formatValue(order.order_name)}`,
          `고객번호: ${formatValue(order.number)}`,
          ...getItemsInfo(),
          `배송주소: ${formatValue(order.addressnum) + ' ' + formatValue(order.address) + ' ' + formatValue(order.addressdetail)}`,
          `보호자성함: ${formatValue(order.guardname)}`,
          `연락처: ${formatValue(order.phone1)}`,
          `담당자: ${formatValue(order.manager)}`,
          `메모: ${formatValue(order.comment)}`,
        ].join('\n');

        // 클립보드 복사
        const copyToClipboard = async (text) => {
          if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
          } else {
            // fallback 방식
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();

            try {
              const successful = document.execCommand('copy');
              document.body.removeChild(textArea);
              if (!successful) {
                throw new Error('복사 실패');
              }
            } catch (error) {
              document.body.removeChild(textArea);
              throw error;
            }
          }
        };

        // 클립보드에 복사하기
        copyToClipboard(copyData)
          .then(() => {
            this.$sentry.logWithComponent('OrderPage', 'info', '주문서 복사 성공', {
              logType: 'success',
              companykey: this.$globalState.company_key,
              userAction: {
                action: 'copyOrderData',
                orderId: order.num,
                orderName: order.order_name,
                activeStatus: this.activeStatus
              },
              apiRequest: {
                method: 'CLIPBOARD',
                url: 'navigator.clipboard',
                requestData: { dataLength: copyData.length }
              },
              result: {
                dataLength: copyData.length,
                orderId: order.num,
                orderName: order.order_name
              }
            });


            this.$swal.fire({
              title: '복사 완료',
              text: '주문서 정보가 복사되었습니다.',
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            });
          })
          .catch((error) => {
            // 에러 로깅
            this.$sentry.errorWithComponent('OrderPage', error, {
              logType: 'error',
              companykey: this.$globalState.company_key,
              userAction: {
                action: 'copyOrderData',
                orderId: order.num,
                orderName: order.order_name,
                activeStatus: this.activeStatus
              },
              apiRequest: {
                method: 'CLIPBOARD',
                url: 'navigator.clipboard',
                requestData: { dataLength: copyData.length }
              },
              errorMessage: error.message,
              errorStack: error.stack
            });

            console.error('복사 실패:', error);
            this.$swal.fire({
              title: '복사 실패',
              text: '복사 중 오류가 발생했습니다. 다시 시도해주세요.',
              icon: 'error',
              confirmButtonText: '확인'
            });
          });

        this.saveState();
      } catch (error) {
        this.$sentry.errorWithComponent('OrderPage', error, {
          logType: 'error',
          companykey: this.$globalState.company_key,
          userAction: {
            action: 'copyOrderData',
            orderId: order?.num,
            activeStatus: this.activeStatus
          },
          apiRequest: {
            method: 'CLIPBOARD',
            url: 'navigator.clipboard',
            requestData: { orderId: order?.num }
          },
          errorMessage: error.message,
          errorStack: error.stack
        });

        console.error('주문서 복사 처리 중 오류:', error);
      }
    },

    async handleContentsSizeChange() {
      this.currentPage = 1; // 페이지를 1로 초기화
      this.selectedOrderIds = []; // 선택된 주문 초기화
      this.selectAll = false; // 전체 선택 초기화
      await this.fetchOrders();
      this.saveState();
    },
    fetchStatus(status) {
      this.activeStatus = status; // 활성화된 상태 업데이트
      this.searchParams.status = status;
      this.currentPage = 1; // 페이지 초기화
      this.selectedOrderIds = []; // 선택된 주문 초기화
      this.selectAll = false; // 전체 선택 초기화

      // 특정 탭(산소, 당뇨, 보장구)을 클릭한 경우 orderType 설정
      if (status === 1) {
        this.searchParams.orderType = 'oxygen';
      } else if (status === 2) {
        this.searchParams.orderType = 'diabetes';
      } else if (status === 3) {
        this.searchParams.orderType = 'assistance';
      } else {
        // 전체 탭인 경우 orderType 초기화
        this.searchParams.orderType = '';
      }

      this.fetchOrders();
      this.fetchStatusCounts();
      this.saveState();
    },
    toggleOrderSelection(orderId) {
      const index = this.selectedOrderIds.indexOf(orderId);
      if (index === -1) {
        this.selectedOrderIds.push(orderId);
      } else {
        this.selectedOrderIds.splice(index, 1);
      }
      this.saveState();
    },

    // 주문서 삭제 확인 =====================================================================
    confirmDeleteOrders() {
      if (this.selectedOrderIds.length === 0) {
        this.$swal.fire({
          title: '알림',
          text: '삭제할 주문서를 선택해주세요.',
          icon: 'warning',
          confirmButtonText: '확인',
          confirmButtonColor: '#0f4c5c',
        });
        return;
      }

      this.$swal.fire({
        title: '정말 삭제하시겠습니까?',
        html: '<div style="font-size: 16px; font-weight: bold; text-align: center;">선택한 주문서를 삭제하시겠습니까?</div>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '삭제',
        confirmButtonColor: '#0f4c5c',
        cancelButtonText: '취소'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteSelectedOrders();
        }
      });
    },

    // 주문서 삭제 =====================================================================
    async deleteSelectedOrders() {
      try {
        // 로딩 표시 시작
        this.$swal.fire({
          title: '삭제 중...',
          html: '주문서를 삭제하고 있습니다.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });

        const totalOrders = this.selectedOrderIds.length;
        let successCount = 0;
        let failCount = 0;

        // 모든 삭제 요청을 Promise 배열로 만들어 병렬 처리
        const deletePromises = this.selectedOrderIds.map(async (orderId) => {
          try {
            const response = await this.$axios.delete(`${this.$apiUrls.hanqmedi}/order/${orderId}`);
            if (response.status === 200) {
              successCount++;
            }
          } catch (error) {
            failCount++;
            console.error(`주문서 ID ${orderId} 삭제 실패:`, error);
          }
        });

        // 모든 삭제 요청이 완료될 때까지 대기
        await Promise.all(deletePromises);

        this.$sentry.logWithComponent('OrderPage', 'info', '주문서 삭제 완료', {
          logType: 'success',
          companykey: this.$globalState.company_key,
          userAction: {
            action: 'deleteSelectedOrders',
            selectedOrderIds: this.selectedOrderIds,
            totalOrders: totalOrders,
            activeStatus: this.activeStatus
          },
          apiRequest: {
            method: 'DELETE',
            url: `${this.$apiUrls.hanqmedi}/order`,
            requestData: { orderIds: this.selectedOrderIds }
          },
          result: {
            successCount: successCount,
            failCount: failCount,
            successRate: totalOrders > 0 ? (successCount / totalOrders * 100).toFixed(2) + '%' : '0%'
          }
        });

        // 결과 메시지 표시
        if (successCount > 0) {
          await this.$swal.fire({
            title: '삭제 완료',
            text: `총 ${totalOrders}개 중 ${successCount}개의 주문서가 삭제되었습니다.${failCount > 0 ? ` (${failCount}개 실패)` : ''
              }`,
            icon: successCount === totalOrders ? 'success' : 'warning',
            confirmButtonText: '확인'
          });
        } else {
          await this.$swal.fire({
            title: '삭제 실패',
            text: '주문서 삭제 중 오류가 발생했습니다.',
            icon: 'error',
            confirmButtonText: '확인'
          });
        }

        // 주문서 목록 새로고침 및 선택 초기화
        this.fetchOrders();
        this.selectedOrderIds = [];
        this.saveState();

      } catch (error) {
        await this.$swal.close(); // 로딩 표시 닫기

        this.$sentry.errorWithComponent('OrderPage', error, {
          logType: 'error',
          companykey: this.$globalState.company_key,
          userAction: {
            action: 'deleteSelectedOrders',
            selectedOrderIds: this.selectedOrderIds,
            totalOrders: this.selectedOrderIds.length,
            activeStatus: this.activeStatus
          },
          apiRequest: {
            method: 'DELETE',
            url: `${this.$apiUrls.hanqmedi}/order`,
            requestData: { orderIds: this.selectedOrderIds }
          },
          errorMessage: error.message,
          errorStack: error.stack
        });

        console.error('주문서 삭제 처리 중 오류:', error);
        await this.$swal.fire({
          title: '오류',
          text: '주문서 삭제 처리 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    truncateComment(comment) {
      if (!comment) {
        return '';
      } else if (comment.length > 8) {
        return comment.slice(0, 8) + '...';
      }
      return comment;
    },

    // 주문서 목록 조회 =====================================================================
    async fetchOrders() {
      try {
        if (this.activeStatus === 5) return await this.fetchReturnOrders();
        if (this.activeStatus === 6) return await this.fetchAsOrders();

        this.orders = [];

        const token = localStorage.getItem('token');
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const params = {
          page: this.currentPage,
          sdate: this.repace_date_hipen(this.startDate),
          edate: this.repace_date_hipen(this.endDate),
          contentsSize: this.contentsSize,
          companykey: currentCompanyKey,
        };

        if (this.searchParams) {
          const {
            bcode,
            name3,
            delivery_status,
            delivery_method,
            centerName,
            manager,
            phone1,
            orderType
          } = this.searchParams;

          Object.assign(params, {
            ...(bcode && { barcode: bcode.trim() }),
            ...(name3 && { name3: name3.trim() }),
            ...(delivery_status && { delivery_status }),
            ...(delivery_method && { delivery_method }),
            ...(centerName && { centerName }),
            ...(manager && { manager }),
            ...(phone1 && { phone1 }),
            ...(orderType && { orderType })
          });
        }

        if (this.searchQuery?.trim()) {
          params.search = this.searchQuery.trim();
        }

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orders`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          params
        });

        this.$sentry.logWithComponent('OrderPage', 'info', '주문 목록 조회 성공', {
          logType: 'success',
          companykey: currentCompanyKey,
          userAction: {
            action: 'fetchOrders',
            activeStatus: this.activeStatus,
            searchQuery: this.searchQuery,
            searchParamsKeys: Object.keys(this.searchParams || {}),
            currentPage: this.currentPage,
            contentsSize: this.contentsSize
          },
          apiRequest: {
            method: 'GET',
            url: `${this.$apiUrls.hanqmedi}/orders`,
            requestData: params
          },
          pagination: {
            currentPage: response.data.currentPage,
            totalPages: response.data.totalPages,
            totalOrders: response.data.totalOrders
          },
          resultCount: response.data.orders?.length || 0
        });

        if (response.data.orders?.length) {
          // 반품/AS 제외
          const filteredOrders = response.data.orders.filter(
            o => o.status !== 5 && !o.as_start_date
          );

          this.orders = filteredOrders.map(order => ({
            ...order,
            target: this.formatTarget(order),
            selected: false,
            displayName:
              order.hasSetProduct && order.set_names ? order.set_names : null
          }));

          // 상태 업데이트
          this.currentPage = response.data.currentPage;
          this.totalPages = response.data.totalPages;
          this.totalOrders = response.data.totalOrders;
          if (response.data.status_cnt) this.status_cnt = response.data.status_cnt;
          this.selectAll = false;

          this.loadAllClaimStatuses();
        } else {
          const hasSearchConditions =
            (this.searchQuery && this.searchQuery.trim() !== '') ||
            Object.values(this.searchParams || {}).some(
              value =>
                value !== null &&
                value !== undefined &&
                value !== '' &&
                value !== '0'
            );

          if (hasSearchConditions) {
            const readableConditions = [];
            const p = this.searchParams || {};

            if (p.bcode) readableConditions.push(`바코드: ${p.bcode}`);
            if (p.name3) readableConditions.push(`품목명: ${p.name3}`);
            if (p.centerName) readableConditions.push(`센터명: ${p.centerName}`);
            if (p.manager) readableConditions.push(`담당자: ${p.manager}`);
            if (p.phone1) readableConditions.push(`연락처: ${p.phone1}`);
            if (p.orderType) {
              const labels = {
                normal: '구입',
                rental: '대여',
                oxygen: '산소',
                assistance: '보장구',
                diabetes: '당뇨'
              };
              const translated = p.orderType
                .split(',')
                .map(t => labels[t.trim()] || t.trim())
                .join(', ');
              readableConditions.push(`구분: ${translated}`);
            }

            // 검색 결과 없음 로깅
            this.$sentry.logWithComponent('OrderPage', 'warning', '검색 결과 없음', {
              logType: 'warning',
              action: 'fetchOrders',
              searchQuery: this.searchQuery,
              conditions: readableConditions
            });

            this.$swal.fire({
              title: '검색 결과 없음',
              text: '조건에 맞는 주문 내역이 없습니다.',
              icon: 'info',
              confirmButtonText: '확인'
            });
          }

          // 상태 초기화
          Object.assign(this, {
            orders: [],
            currentPage: 1,
            totalPages: 0,
            totalOrders: 0,
            selectAll: false
          });
        }

        this.saveState();

      } catch (error) {
        const ignoredMessages = ['Network Error', 'timeout', 'Request aborted'];
        if (ignoredMessages.some(msg => error.message?.includes(msg))) return;

        this.$sentry.errorWithComponent('OrderPage', error, {
          activeStatus: this.activeStatus,
          searchQuery: this.searchQuery,
          page: this.currentPage,
          contentsSize: this.contentsSize,
          userAction: {
            action: 'fetchOrders',
            activeStatus: this.activeStatus,
            searchQuery: this.searchQuery,
            searchParamsKeys: Object.keys(this.searchParams || {}),
            currentPage: this.currentPage,
            contentsSize: this.contentsSize
          },
          apiRequest: {
            method: 'GET',
            url: `${this.$apiUrls.hanqmedi}/orders`,
            requestData: params
          }
        });

        console.error('주문 데이터를 가져오는 중 오류 발생:', error);
        this.$swal.fire({
          title: '오류 발생',
          text: '주문 데이터를 불러오는 중 오류가 발생했습니다.',
          icon: 'error',
          confirmButtonText: '확인'
        });
      }
    },

    // A/S =====================================================================
    async fetchAsOrders() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getAsOrders`, {
          params: {
            asSearch: this.searchQuery,
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate),
            companykey: currentCompanyKey
          }
        });

        console.log('A/S 주문 응답:', response.data);
        if (response.data.success) {
          this.asItems = response.data.data.map(item => ({
            ...item,
            selected: false
          }));

          this.$sentry.logWithComponent('OrderPage', 'info', 'A/S 주문 조회 성공', {
            logType: 'success',
            companykey: currentCompanyKey,
            userAction: {
              action: 'fetchAsOrders',
              searchQuery: this.searchQuery,
              startDate: this.formatDate(this.startDate),
              endDate: this.formatDate(this.endDate),
              activeStatus: this.activeStatus
            },
            apiRequest: {
              method: 'GET',
              url: `${this.$apiUrls.hanqmedi}/getAsOrders`,
              requestData: {
                asSearch: this.searchQuery,
                startDate: this.formatDate(this.startDate),
                endDate: this.formatDate(this.endDate),
                companykey: currentCompanyKey
              }
            },
            result: {
              resultCount: this.asItems.length,
              success: response.data.success
            }
          });

          // 전역 상태에 A/S 주문 목록 저장 (핵심!)
          if (!this.$globalState.asOrders) {
            this.$globalState.asOrders = [];
          }
          this.$globalState.asOrders = this.asItems;

        } else {
          // 결과 없음 로그
          this.$sentry.logWithComponent('OrderPage', 'warning', 'A/S 주문 조회 결과 없음', {
            logType: 'warning',
            companykey: currentCompanyKey,
            userAction: {
              action: 'fetchAsOrders',
              searchQuery: this.searchQuery,
              startDate: this.formatDate(this.startDate),
              endDate: this.formatDate(this.endDate),
              activeStatus: this.activeStatus
            },
            apiRequest: {
              method: 'GET',
              url: `${this.$apiUrls.hanqmedi}/getAsOrders`,
              requestData: {
                asSearch: this.searchQuery,
                startDate: this.formatDate(this.startDate),
                endDate: this.formatDate(this.endDate),
                companykey: currentCompanyKey
              }
            },
            result: {
              resultCount: 0,
              success: response.data.success
            }
          });

          this.asItems = [];
        }
        this.saveState();
      } catch (error) {
        this.$sentry.errorWithComponent('OrderPage', error, {
          logType: 'error',
          companykey: this.$globalState.company_key,
          userAction: {
            action: 'fetchAsOrders',
            searchQuery: this.searchQuery,
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate),
            activeStatus: this.activeStatus
          },
          apiRequest: {
            method: 'GET',
            url: `${this.$apiUrls.hanqmedi}/getAsOrders`,
            requestData: {
              asSearch: this.searchQuery,
              startDate: this.formatDate(this.startDate),
              endDate: this.formatDate(this.endDate),
              companykey: this.$globalState.company_key
            }
          },
          errorMessage: error.message,
          errorStack: error.stack
        });

        this.asItems = [];
        console.error('A/S 주문 데이터를 가져오는 중 오류가 발생했습니다:', error);
      }
    },

    // 반품 =====================================================================
    async fetchReturnOrders() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/getReturnOrders`, {
          params: {
            returnSearch: this.searchQuery,
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate),
            companykey: currentCompanyKey
          }
        });
        if (response.data.success) {
          this.returnItems = response.data.data.map(item => {
            let productNames = [];
            let totalQuantity = 0;

            if (item.products && Array.isArray(item.products) && item.products.length > 0) {
              productNames = item.products.map(product => {
                // name3가 없으면 name2, name1, name0, product_name 순서로 대체
                let productName = product.name3 || product.name2 || product.name1 || product.name0 || product.product_name || '반품품목';
                const quantity = product.quantity;
                totalQuantity += quantity;
                return productName;
              });
            } else {
              productNames = [item.product_names || '반품품목'];
              totalQuantity = item.total_quantity || 0;
            }

            return {
              ...item,
              selected: false,
              // 템플릿에서 사용하는 필드명으로 매핑
              return_start_date: item.return_date,
              order_name: item.original_order_name, // 고객명은 original_order_name 사용
              phone1: item.phone1,
              phone2: item.phone2,
              b_name3: productNames.join(', '),
              name2: productNames.join(', '),
              quantity: totalQuantity,
              total_quantity: totalQuantity,
              manager: item.manager,
              memo: item.comment_memo || '',
              return_request_note: item.return_request_note,
              return_status: item.return_status || 0,
              return_type: item.return_type || 0,
              num: item.return_order_id,
              original_order_id: item.original_order_id,
              original_order_date: item.original_order_date,
              original_order_name: item.original_order_name,
              products: item.products || []
            };
          });
          // 반품 주문서 수 업데이트
          this.returnOrderCount = this.returnItems.length;

        } else {
          this.$sentry.logWithComponent('OrderPage', 'warning', '반품 주문 조회 결과 없음', {
            logType: 'warning',
            companykey: currentCompanyKey,
            userAction: {
              action: 'fetchReturnOrders',
              searchQuery: this.searchQuery,
              startDate: this.formatDate(this.startDate),
              endDate: this.formatDate(this.endDate),
              activeStatus: this.activeStatus
            },
            apiRequest: {
              method: 'GET',
              url: `${this.$apiUrls.hanqmedi}/getReturnOrders`,
              requestData: {
                returnSearch: this.searchQuery,
                startDate: this.formatDate(this.startDate),
                endDate: this.formatDate(this.endDate),
                companykey: currentCompanyKey
              }
            },
            result: {
              resultCount: 0,
              returnOrderCount: 0,
              success: response.data.success
            }
          });

          this.returnItems = [];
          this.returnOrderCount = 0;
        }
        this.saveState();
      } catch (error) {
        this.$sentry.errorWithComponent('OrderPage', error, {
          logType: 'error',
          companykey: this.$globalState.company_key,
          userAction: {
            action: 'fetchStatusCounts',
            activeStatus: this.activeStatus
          },
          apiRequest: {
            method: 'GET',
            url: `${this.$apiUrls.hanqmedi}/orderStatusCounts`,
            requestData: {
              companykey: this.$globalState.company_key
            }
          },
          errorMessage: error.message,
          errorStack: error.stack
        });

        this.returnItems = [];
        this.returnOrderCount = 0;
        console.error('반품 주문 데이터를 가져오는 중 오류가 발생했습니다:', error);
      }
    },

    // 상태 카운트 =====================================================================
    async fetchStatusCounts() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        const response = await this.$axios.get(`${this.$apiUrls.hanqmedi}/orderStatusCounts`, {
          params: {
            companykey: currentCompanyKey
          },
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });

        if (response.data && response.data.success && response.data.status_cnt) {
          this.status_cnt = response.data.status_cnt;
        }
      } catch (error) {
        // 에러 로깅
        this.$sentry.errorWithComponent('OrderPage', error, {
          action: 'fetchStatusCounts',
          activeStatus: this.activeStatus,
          errorMessage: error.message,
          errorStack: error.stack
        });

        console.error('주문 상태별 카운트 조회 실패:', error);
      }
    },

    // 포맷팅 관련 =====================================================================
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatTarget(order) {
      // rental_id가 존재하면 대여로 판단
      if (order.rental_id) {
        return '대여';
      }
      return order.target === '구입 또는 대여' ? '구입' : order.target;
    },
    formatName2(name2) {
      if (!name2) return '';

      // name2가 null이거나 빈 문자열인 경우 b_name 시리즈 사용
      if (name2 === null || name2 === '') {
        return '';
      }

      const items = name2.split(',').map(item => item.trim()).filter(item => item !== "null" && item !== '');
      if (items.length === 0) return '';
      if (items.length === 1) return items[0];

      return `${items[0]} 외 ${items.length - 1}개`;
    },
    formatHubName(hubName) {
      if (!hubName) return '';

      // hub_name1이 null이거나 빈 문자열인 경우
      if (hubName === null || hubName === '') {
        return '';
      }

      const items = hubName.split(',').map(item => item.trim()).filter(item => item !== "null" && item !== '');
      if (items.length === 0) return '';
      if (items.length === 1) return items[0];

      return `${items[0]} 외 ${items.length - 1}개`;
    },

    // 상태 관련 =====================================================================
    setDateRange(range) {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      const date = today.getDate();

      switch (range) {
        case 'today':
          this.startDate = new Date(year, month, date);
          this.endDate = new Date(year, month, date);
          break;
        case 'yesterday':
          this.startDate = new Date(year, month, date - 1);
          this.endDate = new Date(year, month, date - 1);
          break;
        case 'thisMonth':
          this.startDate = new Date(year, month, 1);
          this.endDate = new Date(year, month + 1, 0);
          break;
        case 'lastMonth':
          this.startDate = new Date(year, month - 1, 1);
          this.endDate = new Date(year, month, 0);
          break;
        case 'all':
          this.startDate = new Date(1999, 0, 1);
          this.endDate = new Date(2099, 0, 1);
          break;
      }
      this.fetchOrders();
      this.fetchTypeCounts(); // 날짜 범위 변경 시 타입별 카운트도 다시 조회
      this.saveState();
    },
    repace_date_hipen(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },
    removeFilter(key) {
      if (this.searchParams[key]) {
        delete this.searchParams[key];
      }
      if (key === 'search') {
        this.searchQuery = '';
      }
      this.currentPage = 1;
      this.fetchOrders();
    },
    getFilterTitle(key) {
      const filterTitles = {
        delivery_status: '배송상태',
        delivery_method: '배송방법',
        orderType: '구분',
        printOption: '인쇄',
        name3: '품목명',
        centerName: '센터명',
        manager: '담당자',
        phone1: '연락처',
        bcode: '바코드',
        account: '가상계좌 상태',
        balju: '발주 상태',
        search: '검색어',
        sdate: '시작일',
        edate: '종료일'
      };
      return filterTitles[key] || key;
    },
    getFilterValue(key, value) {
      // 배송상태 값 변환
      if (key === 'delivery_status') {
        const statusMap = {
          '1': '배송완료',
          '2': '배송대기',
          '3': '회수중',
          '4': '회수완료'
        };
        return statusMap[value] || value;
      }

      // 배송방법 값 변환
      if (key === 'delivery_method') {
        const methodMap = {
          '1': '내방',
          '2': '택배',
          '3': '물류',
          '4': '소독업체',
          '5': '공급업체'
        };
        return methodMap[value] || value;
      }

      // 구분 값 변환
      if (key === 'orderType') {
        const typeMap = {
          'normal': '구입',
          'rental': '대여',
          'oxygen': '산소',
          'diabetes': '당뇨',
          'assistance': '보장구'
        };
        return typeMap[value] || value;
      }

      return value;
    },
    getAsStatus(status) {
      const statuses = {
        0: '접수',
        1: '승인',
        2: '수리중',
        3: '검수',
        4: '완료'
      };
      return statuses[status] || '접수';
    },
    getDeliveryMethod(code) {
      const methods = {
        1: '직접전달',
        2: '택배',
        3: '물류',
        4: '소독',
        5: '공급'
      };
      return methods[code] || '';
    },
    getDeliveryStatus(code) {
      const statuses = {
        1: '배송완료',
        2: '배송대기',
        3: '회수중',
        4: '회수완료'
      };
      return statuses[code] || '';
    },
    getConsultingStatus(order) {
      if (order.payment === '기타') {
        return 'o';
      }
      return 'x';
    },

    // 모달 및 팝업 관련 =====================================================================
    openModifyModal(order) {
      this.selectedOrder = JSON.parse(JSON.stringify(order));
      this.showModifyModal = true;
      this.saveState();
    },
    openSmsListModal() {
      this.showSmsListModal = true;
      this.saveState();
    },
    showSearchPopup() {
      this.$swal.fire({
        title: '상세 검색',
        width: "25%",
        html: '<div id="search-popup"></div>',
        showCancelButton: true,
        confirmButtonText: '검색',
        cancelButtonText: '취소',
        confirmButtonColor: '#0f4c5c',
        cancelButtonColor: '#6c757d',
        allowEnterKey: true,
        didOpen: () => {
          const app = createApp({
            setup() {
              const componentRef = ref(null);
              return { componentRef };
            },
            render: () => h(SearchPopup, {
              ref: 'componentRef',
              searchParams: this.searchParams
            })
          });
          const instance = app.mount('#search-popup');
          this.searchPopupInstance = instance.componentRef;
        },
        preConfirm: () => {
          if (this.searchPopupInstance && typeof this.searchPopupInstance.getFormValues === 'function') {
            const values = this.searchPopupInstance.getFormValues();

            // 각 필드별로 여러 값을 처리
            const processMultiValues = (value) => {
              if (!value) return value;
              return value.split(',')
                .map(item => item.trim())
                .filter(item => item !== '')
                .join(',');
            };

            // 모든 검색 조건 처리
            const processedValues = {
              sdate: values.sdate || '19990101',
              edate: values.edate || '20990101',
              delivery_status: processMultiValues(values.delivery_status),
              delivery_method: processMultiValues(values.delivery_method),
              orderType: processMultiValues(values.orderType), // orderType 처리 추가
              name3: processMultiValues(values.name3),
              centerName: processMultiValues(values.centerName),
              manager: processMultiValues(values.manager),
              phone1: processMultiValues(values.phone1),
              bcode: processMultiValues(values.bcode),
            };

            return processedValues;
          } else {
            console.error('getFormValues method not found');
            return {};
          }
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.searchParams = result.value;
          this.currentPage = 1; // 검색 시 첫 페이지로 이동
          this.fetchOrders();
        }
      });
    },

    async closeModal() {
      // 주문서 입력 모달 닫기 추가
      this.showModal = false;

      // 주문서 수정 모달 닫기 (기존)
      this.showModifyModal = false;
      this.selectedOrder = null;

      // 일반 주문서 데이터 새로고침
      await this.fetchOrders();

      this.saveState();
    },

    async closeAsModal() {
      this.showModifyModal = false;
      this.selectedOrder = null;

      // A/S 탭이 활성화된 경우 A/S 데이터 새로고침
      if (this.activeStatus === 6) {
        await this.fetchAsOrders();
      }

      // 일반 주문서 데이터도 새로고침
      await this.fetchOrders();

      this.saveState();
    },

    async closeReturnModal() {
      this.showModifyModal = false;
      this.selectedOrder = null;

      // 반품 데이터 새로고침
      await this.fetchOrders();
      await this.fetchReturnOrders();

      this.saveState();
    },

    handlePaymentUpdated({ orderId, payment }) {
      // orders 배열에서 해당 주문서의 payment를 즉시 업데이트
      const orderIndex = this.orders.findIndex(o => o.num === orderId);
      if (orderIndex !== -1) {
        this.orders[orderIndex].payment = payment;
        // Vue의 반응성을 위해 강제 업데이트
        this.$forceUpdate();
      }
    },

    // 상태 저장 섹션 =====================================================================
    saveState() {
      const state = {
        // 검색 관련 상태
        searchQuery: this.searchQuery,

        // 날짜 범위 상태
        startDate: this.startDate,
        endDate: this.endDate,

        // 필터 상태
        searchParams: this.searchParams,
        activeStatus: this.activeStatus,

        // 페이지네이션 상태
        currentPage: this.currentPage,
        contentsSize: this.contentsSize,

        // 모달 상태
        showModal: this.showModal,
        showModifyModal: this.showModifyModal,
        showSmsListModal: this.showSmsListModal,

        // 선택된 주문 (모달에 표시되는 주문)
        selectedOrderId: this.selectedOrder ? this.selectedOrder.num : null,

        // 선택된 주문 ID 목록
        selectedOrderIds: this.selectedOrderIds,

        // 마지막 방문 시간 저장
        lastVisit: new Date().getTime()
      };

      localStorage.setItem('orderPageState', JSON.stringify(state));

      // 새로고침 감지를 위한 세션 스토리지 설정
      sessionStorage.setItem('orderPageVisited', 'true');
    },

    // 상태 복원 메서드 추가
    async restoreState() {
      const isRefresh = sessionStorage.getItem('orderPageVisited') === 'true';

      // 새로고침인 경우 상태를 복원하지 않고 초기화
      if (isRefresh) {
        localStorage.removeItem('orderPageState');
        sessionStorage.removeItem('orderPageVisited');

        // 기본값으로 초기화
        this.currentPage = 1;
        this.searchQuery = '';
        this.searchParams = {
          delivery_status: '',
          delivery_method: '',
          orderType: '',
          name3: '',
          centerName: '',
          manager: '',
          phone1: '',
          bcode: '',
          status: '0',
        };

        // 현재 companykey로 새로운 데이터 조회
        await this.fetchOrders();
        return;
      }

      const savedState = localStorage.getItem('orderPageState');
      if (!savedState) return;

      try {
        const state = JSON.parse(savedState);

        // 검색 관련 상태 복원
        this.searchQuery = state.searchQuery || '';

        // 날짜 범위 상태 복원
        if (state.startDate) this.startDate = new Date(state.startDate);
        if (state.endDate) this.endDate = new Date(state.endDate);

        // 필터 상태 복원
        if (state.searchParams) this.searchParams = state.searchParams;
        if (state.activeStatus !== undefined) this.activeStatus = state.activeStatus;

        // 페이지네이션 상태 복원
        this.currentPage = state.currentPage || 1;
        this.contentsSize = state.contentsSize || 10;

        // 선택된 주문 ID 목록 복원
        if (state.selectedOrderIds) this.selectedOrderIds = state.selectedOrderIds;

        // 데이터 로드
        await this.fetchOrders();

        // 모달 상태 복원
        if (state.showModal) this.showModal = state.showModal;
        if (state.showSmsListModal) this.showSmsListModal = state.showSmsListModal;

        // 상세 모달 및 선택된 주문 복원
        if (state.showModifyModal && state.selectedOrderId) {
          // 선택된 주문 찾기
          let selectedOrder = null;

          if (this.activeStatus === 5) {
            selectedOrder = this.returnItems.find(order => order.num === state.selectedOrderId);
          } else if (this.activeStatus === 6) {
            selectedOrder = this.asItems.find(order => order.num === state.selectedOrderId);
          } else {
            selectedOrder = this.orders.find(order => order.num === state.selectedOrderId);
          }

          if (selectedOrder) {
            this.selectedOrder = JSON.parse(JSON.stringify(selectedOrder));
            this.showModifyModal = true;
          }
        }
      } catch (error) {
        console.error('상태 복원 중 오류 발생:', error);
        localStorage.removeItem('orderPageState');
      }
    },

    toggleAll() {
      this.orders.forEach(order => {
        order.selected = this.selectAll;
        this.toggleOrderSelection(order.num);
      });
      this.saveState();
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.selectedOrderIds = []; // 페이지 이동 시 선택된 주문 초기화
        this.selectAll = false; // 전체 선택 상태 초기화
        this.fetchOrders();
        this.saveState();
      }
    },

    showDevelopmentMessage() {
      this.$swal.fire({
        title: '개발 중',
        text: '현재 개발 중인 기능입니다.',
        icon: 'info',
        confirmButtonColor: '#3085d6',
        confirmButtonText: '확인'
      });
    },

    // 타입별 카운트 조회 =====================================================================
    async fetchTypeCounts() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentCompanyKey = userInfo?.company_key || this.$globalState.company_key;

        if (!currentCompanyKey) {
          console.warn('company_key가 없어서 타입별 카운트를 조회할 수 없습니다.');
          return;
        }

        // 각 타입별로 개별 조회
        const [oxygenResponse, diabetesResponse, assistanceResponse] = await Promise.all([
          this.$axios.get(`${this.$apiUrls.hanqmedi}/orders`, {
            params: {
              companykey: currentCompanyKey,
              orderType: 'oxygen',
              sdate: this.repace_date_hipen(this.startDate),
              edate: this.repace_date_hipen(this.endDate),
              contentsSize: 1 // 개수만 필요하므로 1개만 조회
            }
          }),
          this.$axios.get(`${this.$apiUrls.hanqmedi}/orders`, {
            params: {
              companykey: currentCompanyKey,
              orderType: 'diabetes',
              sdate: this.repace_date_hipen(this.startDate),
              edate: this.repace_date_hipen(this.endDate),
              contentsSize: 1
            }
          }),
          this.$axios.get(`${this.$apiUrls.hanqmedi}/orders`, {
            params: {
              companykey: currentCompanyKey,
              orderType: 'assistance',
              sdate: this.repace_date_hipen(this.startDate),
              edate: this.repace_date_hipen(this.endDate),
              contentsSize: 1
            }
          })
        ]);

        this.typeCounts.oxygen = oxygenResponse.data.totalOrders || 0;
        this.typeCounts.diabetes = diabetesResponse.data.totalOrders || 0;
        this.typeCounts.assistance = assistanceResponse.data.totalOrders || 0;

      } catch (error) {
        this.$sentry.errorWithComponent('OrderPage', error, {
          logType: 'error',
          companykey: this.$globalState.company_key,
          userAction: {
            action: 'fetchTypeCounts',
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate),
            activeStatus: this.activeStatus
          },
          apiRequest: {
            method: 'GET',
            url: `${this.$apiUrls.hanqmedi}/orders`,
            requestData: {
              companykey: this.$globalState.company_key,
              orderTypes: ['oxygen', 'diabetes', 'assistance'],
              sdate: this.repace_date_hipen(this.startDate),
              edate: this.repace_date_hipen(this.endDate),
              contentsSize: 1
            }
          },
          errorMessage: error.message,
          errorStack: error.stack
        });

        console.error('타입별 카운트 조회 실패:', error);
        this.typeCounts = { oxygen: 0, diabetes: 0, assistance: 0 };
      }
    },
  },

  async mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (userInfo && userInfo.company_key) {
      // globalState의 company_key 업데이트
      this.$globalState.company_key = userInfo.company_key;
    }

    // 상태 복원 시도
    await this.restoreState();

    // 세션 스토리지 설정
    sessionStorage.setItem('orderPageVisited', 'true');

    // 데이터가 로드되지 않았다면 초기 데이터 로드
    if (this.orders.length === 0 && this.asItems.length === 0 && this.returnItems.length === 0) {
      await this.fetchOrders();
    }

    await this.fetchReturnOrders();

    // 상태 카운트 로드
    await this.fetchStatusCounts();

    // 타입별 카운트 로드 (페이지 접속 시 자동으로 실행)
    await this.fetchTypeCounts();
  },

  // 컴포넌트가 활성화될 때 세션 스토리지 설정
  activated() {
    sessionStorage.setItem('orderPageVisited', 'true');
  },

  // 컴포넌트가 비활성화될 때 상태 저장
  deactivated() {
    this.saveState();
  },

  // 컴포넌트가 파괴될 때 상태 저장
  beforeUnmount() {
    this.saveState();
    // 페이지를 떠날 때 세션 스토리지 제거
    sessionStorage.removeItem('orderPageVisited');
  },

  watch: {
    orders: {
      deep: true,
      handler() {
        if (this.orders.length > 0) {
          this.selectAll = this.orders.every(order => order.selected);
        } else {
          this.selectAll = false;
        }

        // 상태 저장
        this.saveState();
      }
    },
    showModal(newVal) {
      if (newVal) {
        // 모달이 열릴 때
        document.body.style.overflow = 'hidden';
      } else {
        // 모달이 닫힐 때
        document.body.style.overflow = 'auto';
      }

      // 상태 저장
      this.saveState();
    },
    showModifyModal(newVal) {
      if (newVal) {
        // 모달이 열릴 때
        document.body.style.overflow = 'hidden';
        this.fetchOrders();
      } else {
        // 모달이 닫힐 때
        document.body.style.overflow = 'auto';
      }

      // 상태 저장
      this.saveState();
    },
    showSmsListModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }

      // 상태 저장
      this.saveState();
    },
    contentsSize() {
      this.handleContentsSizeChange();
    },
    searchQuery() {
      this.saveState();
    },
    activeStatus() {
      this.saveState();
    },
    searchParams: {
      deep: true,
      handler() {
        this.saveState();
      }
    }
  }
};
</script>

<style scoped>
/* 테이블 내부의 모든 텍스트 데이터를 블러 처리 */
.blurred tbody tr td {
  filter: blur(4px) !important;
}

/* 블러된 요소 내부의 상호작용은 유지 (클릭 가능) */
.blurred * {
  pointer-events: auto;
  user-select: auto;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
}
</style>